// readable names for the program ids the controls dispatch
export const PROGRAM_TITLES = {
  instantHeat: 'instant heat program',
  snowSensor: 'snow sensor program',
  constantTemp: 'optional constant temp. program',
  windFactor: 'wind factor program',
  heatingSchedule: 'heating schedule program',
  ats: 'ats-automatic transfer system',
  shutOff: 'shut off',
  fanOnly: 'fan only',
};

const mainMessageBoxHandler = (
  id,
  scope,
  type,
  programName,
  // specificLocation
) => {
  let openMessage = false;
  let openLocationMessage = false;
  let openSpecificLocationMessage = false;
  let newMessage = [];
  let newMessageTitle = '';

  if (type === 'switches') {
    newMessageTitle = 'locations master control';
  } else {
    newMessageTitle = 'master control';
  }

  // if (specificLocation) {
  //   openSpecificLocationMessage = true;
  // } else if (scope === 'switch') {
  //   openMessage = true;
  // } else {
  //   openLocationMessage = true;
  // }

  switch (id) {
    case 'tempA':
      // instantHeat, heating schedule
      newMessage = [
        'wrong temperature',
        `in order to finalize ${programName},`,
        'please input your temperature first',
        '( the minimum temperature is 121°C - 250°F )',
        '( the maximum temperature is 999°C - 1830°F )',
      ];

      break;
    case 'tempB':
      newMessage = [
        'wrong temperature',
        `in order to finalize ${programName},`,
        'please input your temperature first',
        '( the minimum temperature is 25°C - 77°F )',
        '( the maximum temperature is 120°C - 248°F )',
      ];

      break;
    case 'selectA':
      newMessage = [`select ${type}`, `please select ${type} to continue`];

      break;
    case 'selectB':
      newMessage = [
        `select ${type} and a schedule`,
        `please select ${type} and a start date and end date`,
      ];
      break;

    case 'selectC':
      newMessage = [
        'ats-automatic transfer system',
        'please select ATS option before apply',
      ];
      break;
    case 'selectNone': {
      if (scope === 'switch') {
        openMessage = true;
      } else {
        openLocationMessage = true;
      }
      const target = type ?? (scope === 'switch' ? 'locations' : 'switches');
      newMessage = [
        `select ${target}`,
        `please select ${target} to continue`,
      ];
      break;
    }
    case 'applied':
      // the controls render their own boxes for the error cases above, so this
      // is the only one this handler opens itself
      if (scope === 'switch') {
        openMessage = true;
      } else {
        openLocationMessage = true;
      }
      // shut off dispatches without a type, so fall back to the same rule the
      // controls use to derive it
      newMessage = [
        'changes applied',
        `${programName} was applied to the selected ${
          type ?? (scope === 'switch' ? 'locations' : 'switches')
        }`,
      ];
      break;
    default:
      throw new Error('unknown error', id);
  }

  return {
    openMessage,
    openLocationMessage,
    openSpecificLocationMessage,
    newMessage,
    newMessageTitle,
  };
};

export default mainMessageBoxHandler;
